const DEV_LANDING_FORM_SCRIPT_URL =
  'https://script.google.com/a/macros/caloriescience.ai/s/AKfycbyvdxj_OrgUCmY2iSdHfQY9z8J7TvthOb9fkFGREKktjhGMYPy5VO53oVmGWbx1E2Ya7Q/exec';

export type LandingFormEnvironment = 'prod' | 'dev';

export function getLandingFormEnvironment(): LandingFormEnvironment {
  const viteEnv = import.meta.env.VITE_ENVIRONMENT?.trim().toLowerCase();
  if (viteEnv === 'prod' || viteEnv === 'production') return 'prod';
  if (viteEnv === 'dev' || viteEnv === 'development') return 'dev';

  const apiUrl = import.meta.env.VITE_API_URL?.trim().toLowerCase() ?? '';
  if (apiUrl.includes('api.caloriescience.ai') && !apiUrl.includes('dev-api')) {
    return 'prod';
  }

  return 'dev';
}

export function getLandingFormScriptUrl(): string {
  const configured = import.meta.env.VITE_LANDING_FORM_SCRIPT_URL?.trim();
  if (configured) return configured;

  const environment = getLandingFormEnvironment();
  if (environment === 'prod') {
    const prodUrl = import.meta.env.VITE_LANDING_FORM_SCRIPT_URL_PROD?.trim();
    if (prodUrl) return prodUrl;
  }

  return DEV_LANDING_FORM_SCRIPT_URL;
}
